import React, { ChangeEvent, useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { Col, Row } from "react-bootstrap";
import { axiosGetRequest, axiosPatchRequest } from "../../api/ApiClient";
import DialogMessage from "../../components/DialogMessage";
import {
    ArrowRightIcon,
    CheckIcon,
    CircleXMarkIcon,
    InformationIcon,
    SearchIcon,
} from "../../components/Icons";
import PaginationLocal from "../../components/PaginationLocal";
import AprovacaoPlanoAtividadeDTO from "../../model/dto/AprovacaoPlanoAtividadeDTO";
import ModalCallback from "../../model/ModalCallback";
import ButtonStyles from "../../styles/components/ButtonStyles";
import {
    StyledBody,
    StyledFormCheck,
    StyledFormControlSearch,
    StyledHeader,
    StyledInputGroupSearch,
    StyledInputGroupTextSearch,
    StyledSubTitle,
    StyledTitle,
} from "../../styles/MainStyles";
import {
    StyledCardActivityPlan,
    StyledCardAvailableHours,
    StyledCardEmpty,
    StyledCardGrey,
    StyledCardHour,
    StyledCardTeacher,
    StyledCardTitle,
    StyledDefaultButtonLink,
} from "../../styles/pages/TaskManagement/TaskManagementStyles";
import GenericUtils from "../../utils/GenericUtils";
import StringUtils from "../../utils/types/StringUtils";
import ModalDetailsAcademicActivity, {
    IModalDetailsAcademicActivityProps,
} from "../AcademicActivityPlan/ModalDetailsAcademicActivity";
import ModalRequestAdjustment from "./ModalRquestAdjustment";
import InputLabelTextArea from "../../components/InputLabelTextArea";

function TaskManagement() {
    const { instance } = useMsal();
    const acessToken = GenericUtils.getAccessTokenDocente();

    const translate = {
        operationSuccess: StringUtils.translate("operationSuccess"),
        operationFailure: StringUtils.translate("operationFailure"),
    };

    const [activityPlans, setActivityPlans] = useState<any[]>([]);
    const [idSelected, setIdSelected] = useState(0);
    // Check
    const [checked, setChecked] = useState<any[]>([]);
    const [checkAll, setCheckAll] = useState(false);
    // Filter
    const [search, setSearch] = useState("");
    const [filteredItems, setFilteredItems] = useState<any[]>([]);
    // Paginate
    const [paginatedItems, setPaginatedItems] = useState<any[]>([]);
    // Modal
    const [openModalRequestAdjustment, setOpenModalRequestAdjustment] =
        useState(false);
    const [
        modalDetailsAcademicActivityProps,
        setModalDetailsAcademicActivityProps,
    ] = useState<IModalDetailsAcademicActivityProps>(Object.create({}));
    // Dialog
    const [openDialogApprove, setOpenDialogApprove] = useState(false);
    const [openDialogApproveGroup, setOpenDialogApproveGroup] = useState(false);
    const [justificationDialogApprove, setJustificationDialoApprove] =
        useState<string>("");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const { isDac, isCord, docente } = GenericUtils.getUser();

    async function getActivityPlansApproval() {
        const response = await axiosGetRequest(
            `/docente/v1/usuarios/${GenericUtils.getUserAdp()}/planos-atividade-aprovacao?_limit=99999`,
            acessToken,
            instance
        );

        if (GenericUtils.isSuccessStatus(response?.status) && response?.data) {
            let retorno;
            if (isCord) {
                retorno = response.data.filter(
                    (linha: { matriculaDocente: string }) =>
                        linha.matriculaDocente !== docente.matriculaAdp
                );
            } else {
                retorno = response.data;
            }
            setActivityPlans(retorno);
        }
    }

    async function statusActivityPlans(dto: AprovacaoPlanoAtividadeDTO) {
        return axiosPatchRequest(
            "/docente/v1/planosatividade/status",
            dto,
            acessToken,
            instance
        );
    }

    const handleCheckAll = (event: any) => {
        if (event?.target?.checked) {
            setCheckAll(true);
        } else {
            setCheckAll(false);
        }
    };

    const handleCheck = (event: any) => {
        if (event?.target?.checked) {
            activityPlans.forEach((item) => {
                if (
                    item.planoAtividadeDocenteId.toString() === event.target.id
                ) {
                    setChecked([...checked, item]);
                }
            });
        } else {
            setChecked(
                checked.filter(
                    (item) =>
                        item.planoAtividadeDocenteId.toString() !==
                        event.target.id
                )
            );
        }
    };

    const initalState = () => {
        getActivityPlansApproval();
        setCheckAll(false);
        setChecked([]);
        setSearch("");
    };

    const approveIndividual = async () => {
        const dto: AprovacaoPlanoAtividadeDTO = {
            aprovacao: true,
            justificava: justificationDialogApprove,
            planoAtividadeDocenteId: [idSelected],
        };

        const response = await statusActivityPlans(dto);

        if (GenericUtils.isSuccessStatus(response.status)) {
            setSuccessMessage("TACH aprovado");
            initalState();
        } else {
            setErrorMessage(
                response.data?.details || translate.operationFailure
            );
        }
    };

    const approveGroup = async () => {
        const dto: AprovacaoPlanoAtividadeDTO = {
            aprovacao: true,
            justificava: justificationDialogApprove,
            planoAtividadeDocenteId: checked.map((item) => {
                return item.planoAtividadeDocenteId;
            }),
        };

        const response = await statusActivityPlans(dto);

        if (GenericUtils.isSuccessStatus(response.status)) {
            setSuccessMessage("TACHs aprovados");
            initalState();
        } else {
            setErrorMessage(
                response.data?.details || translate.operationFailure
            );
        }
    };

    const handleSearchActivityPlans = (
        event: ChangeEvent<{ value: unknown }>
    ) => {
        setSearch(event.target.value as string);
    };

    const handleOpenDialogApproveGroup = () => {
        setOpenDialogApproveGroup(true);
    };

    const handleCloseDialogApproveGroup = (callback?: any) => {
        setOpenDialogApproveGroup(false);
        if (callback?.confirmButton) approveGroup();
    };

    const handleOpenDialogApprove = (id: number) => {
        setIdSelected(id);
        setOpenDialogApprove(true);
    };

    const handleCloseDialogApprove = (callback?: any) => {
        setOpenDialogApprove(false);
        if (callback?.confirmButton) approveIndividual();
    };

    const handleCloseDialogSuccess = () => {
        setSuccessMessage("");
    };

    const handleCloseDialogError = () => {
        setErrorMessage("");
    };

    const handleOpenModalRequestAdjustment = (id: number) => {
        setIdSelected(id);
        setOpenModalRequestAdjustment(true);
    };

    const handleCloseModalRequestAdjustment = (callback?: ModalCallback) => {
        setOpenModalRequestAdjustment(false);
        if (callback?.success) initalState();
    };

    const handleOpenModalDetailsAcademicActivity = (
        teachingActivityPlanId: number
    ) => {
        setModalDetailsAcademicActivityProps({
            open: true,
            teachingActivityPlanId,
        });
    };

    const modalDetailsAcademicActivityPlan =
        modalDetailsAcademicActivityProps.open && (
            <ModalDetailsAcademicActivity
                open={modalDetailsAcademicActivityProps.open}
                teachingActivityPlanId={
                    modalDetailsAcademicActivityProps.teachingActivityPlanId
                }
                onClose={() =>
                    setModalDetailsAcademicActivityProps(Object.create({}))
                }
            />
        );

    useEffect(() => {
        initalState();
    }, []);

    useEffect(() => {
        setChecked(checkAll ? [...activityPlans] : []);
    }, [checkAll]);

    useEffect(() => {
        setFilteredItems(activityPlans);
    }, [activityPlans]);

    useEffect(() => {
        if (search?.trim()) {
            setFilteredItems(
                activityPlans.filter(
                    (item) =>
                        item?.nomeDocente
                            ?.toLowerCase()
                            .includes(search.toLowerCase()) ||
                        item?.matriculaDocente
                            ?.toLowerCase()
                            .includes(search.toLowerCase())
                )
            );
        } else {
            setFilteredItems(activityPlans);
        }
    }, [search]);
    const getValidationButton = () => {
        if (!isDac) return false;

        return !justificationDialogApprove.length;
    };

    const justificationDialog = () => {
        return (
            isDac && (
                <>
                    <p style={{ paddingTop: "10px" }}>
                        Insira abaixo a justificativa.
                    </p>
                    <InputLabelTextArea
                        value={justificationDialogApprove}
                        placeholder="Digite sua justificativa..."
                        onChange={(event: any) => {
                            setJustificationDialoApprove(event.target.value);
                        }}
                        viewLengthInfo
                        maxLength={500}
                        style={{
                            height: "107px",
                            borderStyle: "solid",
                            borderColor: "#787878",
                            width: "100%",
                        }}
                    />
                </>
            )
        );
    };

    const dialogApproveGroup = (
        <DialogMessage
            type="question"
            show={openDialogApproveGroup}
            title="Aprovar todos os TACHs selecionados?"
            textButton="Aprovar"
            textButtonClose="Cancelar"
            disableConfirmButton={getValidationButton()}
            onClose={handleCloseDialogApproveGroup}
            dialogClassName="modal-create-card"
            style={{ width: "100%" }}
            size="width-600"
        >
            {justificationDialog()}
        </DialogMessage>
    );

    const dialogApprove = (
        <DialogMessage
            type="question"
            show={openDialogApprove}
            title="Deseja aprovar o TACH selecionado?"
            textButton="Aprovar"
            textButtonClose="Cancelar"
            disableConfirmButton={getValidationButton()}
            onClose={handleCloseDialogApprove}
            dialogClassName="modal-create-card"
            style={{ width: "100%" }}
            size="width-600"
        >
            {justificationDialog()}
        </DialogMessage>
    );

    const dialogSuccess = (
        <DialogMessage
            type="success"
            show={Boolean(successMessage)}
            title={successMessage}
            onClose={handleCloseDialogSuccess}
        />
    );

    const dialogError = (
        <DialogMessage
            type="error"
            show={Boolean(errorMessage)}
            title={errorMessage}
            onClose={handleCloseDialogError}
        />
    );

    const modalRequestAdjustment = (
        <ModalRequestAdjustment
            open={openModalRequestAdjustment}
            onClose={handleCloseModalRequestAdjustment}
            activityPlanId={idSelected}
        />
    );

    return (
        <>
            <StyledHeader>
                <StyledTitle>
                    Aprovar TACH (Termo de Acordo de Carga Horária)
                </StyledTitle>
                <StyledSubTitle>
                    Use este espaço para visualizar, deferir ou solicitar
                    ajustes nos TACHs.
                </StyledSubTitle>
            </StyledHeader>
            <StyledBody>
                <StyledCardGrey body>
                    <Row className="align-items-center">
                        <Col xs="12" lg="6" className="mt-3">
                            <StyledFormCheck
                                onChange={handleCheckAll}
                                type="checkbox"
                                label="Selecionar todos"
                                style={{
                                    paddingLeft: "1.75rem",
                                }}
                            />
                        </Col>
                        <Col xs="12" lg="6" className="mt-3">
                            <StyledInputGroupSearch>
                                <StyledInputGroupTextSearch>
                                    <SearchIcon />
                                </StyledInputGroupTextSearch>
                                <StyledFormControlSearch
                                    type="text"
                                    placeholder="Pesquise aqui"
                                    value={search}
                                    onChange={handleSearchActivityPlans}
                                />
                            </StyledInputGroupSearch>
                        </Col>
                    </Row>
                    {paginatedItems.map((item) => (
                        <StyledCardActivityPlan
                            key={item.planoAtividadeDocenteId}
                            body
                            className="mt-3"
                        >
                            <Row>
                                <Col
                                    xs="1"
                                    className="mt-1"
                                    style={{
                                        width: "3.2rem",
                                        paddingLeft: "1.25rem",
                                    }}
                                >
                                    <Row>
                                        <Col>
                                            <StyledFormCheck
                                                type="checkbox"
                                                id={
                                                    item.planoAtividadeDocenteId
                                                }
                                                checked={checked.includes(item)}
                                                onChange={handleCheck}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs="12" lg="6" className="mt-1">
                                    <Row>
                                        <Col>
                                            <StyledCardTitle>{`TACH - ${item.vigencia.semestre}º Semestre ${item.vigencia.ano}`}</StyledCardTitle>
                                            <StyledCardAvailableHours
                                                style={{
                                                    background: "#9654FF",
                                                }}
                                            >
                                                {`${item.horasUtilizadas} h/a utilizadas`}
                                            </StyledCardAvailableHours>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <StyledCardTeacher>
                                                {`${item.nomeDocente} - ${item.matriculaDocente}`}
                                            </StyledCardTeacher>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <StyledCardHour>
                                                {`Enviado em: ${StringUtils.formatDateString(
                                                    item.dataEnvio
                                                )}`}
                                            </StyledCardHour>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs="12" lg="5" className="d-grid mt-1">
                                    <Row className="align-items-center justify-content-center">
                                        <Col xs="12" md="4">
                                            <StyledDefaultButtonLink
                                                style={{ width: "135px" }}
                                                onClick={() =>
                                                    handleOpenModalDetailsAcademicActivity(
                                                        item.planoAtividadeDocenteId
                                                    )
                                                }
                                            >
                                                <ArrowRightIcon
                                                    style={{ marginRight: 5 }}
                                                />
                                                Ver detalhes
                                            </StyledDefaultButtonLink>
                                        </Col>
                                        <Col xs="12" md="5">
                                            <StyledDefaultButtonLink
                                                style={{ width: "150px" }}
                                                onClick={() =>
                                                    handleOpenModalRequestAdjustment(
                                                        item.planoAtividadeDocenteId
                                                    )
                                                }
                                            >
                                                <CircleXMarkIcon
                                                    style={{ marginRight: 5 }}
                                                />
                                                Solicitar ajuste
                                            </StyledDefaultButtonLink>
                                        </Col>
                                        <Col xs="12" md="3">
                                            <StyledDefaultButtonLink
                                                style={{ width: "105px" }}
                                                onClick={() =>
                                                    handleOpenDialogApprove(
                                                        item.planoAtividadeDocenteId
                                                    )
                                                }
                                            >
                                                <CheckIcon
                                                    style={{ marginRight: 5 }}
                                                />
                                                Aprovar
                                            </StyledDefaultButtonLink>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </StyledCardActivityPlan>
                    ))}
                    <PaginationLocal
                        items={filteredItems}
                        itemsPage={5}
                        onPaginate={(items) => setPaginatedItems(items)}
                    />
                    {paginatedItems?.length === 0 && (
                        <StyledCardEmpty body className="mt-3">
                            <InformationIcon />
                            <span>
                                {activityPlans?.length
                                    ? "Não há TACH para ser aprovado."
                                    : "Nenhum resultado encontrado."}
                            </span>
                        </StyledCardEmpty>
                    )}
                </StyledCardGrey>
                <Row className="mt-4">
                    <Col>
                        <ButtonStyles.BtnPrimary
                            disabled={!checked.length}
                            onClick={handleOpenDialogApproveGroup}
                        >
                            Aprovar selecionados
                        </ButtonStyles.BtnPrimary>
                    </Col>
                </Row>
            </StyledBody>
            {openDialogApprove ? dialogApprove : null}
            {openDialogApproveGroup ? dialogApproveGroup : null}
            {successMessage ? dialogSuccess : null}
            {errorMessage ? dialogError : null}
            {openModalRequestAdjustment ? modalRequestAdjustment : null}
            {modalDetailsAcademicActivityPlan}
        </>
    );
}

export default TaskManagement;
